import { EgretLoadable } from 'egret'

const Color = EgretLoadable({
  loader: () => import('./Color')
})

const utilitiesRoutes = [
  {
    path: '/utilities/color',
    component: Color
  }
]

export default utilitiesRoutes
